type DownloadMediaKind = 'image' | 'video' | 'file';

export type DownloadResult = {
  method: 'browser';
  canceled?: boolean;
};

export type DownloadUrlOptions = {
  requestId?: string;
  url: string;
  fileName: string;
  mimeType?: string;
  mediaKind?: DownloadMediaKind;
  saveToPhotos?: boolean;
};

export type DownloadBlobOptions = {
  blob: Blob;
  fileName: string;
  mimeType?: string;
  mediaKind?: DownloadMediaKind;
  saveToPhotos?: boolean;
};

function downloadUrlInBrowser({
  url,
  fileName
}: Pick<DownloadUrlOptions, 'url' | 'fileName'>): DownloadResult {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.target = '_blank';
  link.rel = 'noreferrer';
  document.body.appendChild(link);
  link.click();
  link.remove();
  return { method: 'browser' };
}

function downloadBlobInBrowser(
  blob: Blob,
  fileName: string
): DownloadResult {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  return { method: 'browser' };
}

export function downloadUrl(options: DownloadUrlOptions): DownloadResult {
  return downloadUrlInBrowser(options);
}

export function downloadBlob(options: DownloadBlobOptions): DownloadResult {
  return downloadBlobInBrowser(options.blob, options.fileName);
}
